export type DecodedRealtimeEvent =
  | { kind: 'USER_TRANSCRIPT'; text: string }
  | { kind: 'ASSISTANT_DELTA'; text: string }
  | { kind: 'ASSISTANT_DONE'; text: string }
  | { kind: 'EXTRACTION'; arguments: string }
  | { kind: 'ERROR'; message: string };

export function decodeRealtimeEvent(event: unknown): DecodedRealtimeEvent | null {
  if (!event || typeof event !== 'object' || !('type' in event) || typeof event.type !== 'string')
    return null;
  if (
    event.type === 'conversation.item.input_audio_transcription.completed' &&
    'transcript' in event &&
    typeof event.transcript === 'string'
  ) {
    return { kind: 'USER_TRANSCRIPT', text: event.transcript };
  }
  if (
    event.type === 'response.output_audio_transcript.delta' &&
    'delta' in event &&
    typeof event.delta === 'string'
  ) {
    return { kind: 'ASSISTANT_DELTA', text: event.delta };
  }
  if (
    event.type === 'response.output_audio_transcript.done' &&
    'transcript' in event &&
    typeof event.transcript === 'string'
  ) {
    return { kind: 'ASSISTANT_DONE', text: event.transcript };
  }
  if (
    event.type === 'response.function_call_arguments.done' &&
    'name' in event &&
    event.name === 'submit_intake_extraction' &&
    'arguments' in event &&
    typeof event.arguments === 'string'
  ) {
    return { kind: 'EXTRACTION', arguments: event.arguments };
  }
  if (event.type === 'error') {
    const message =
      'error' in event && event.error && typeof event.error === 'object' && 'message' in event.error
        ? String(event.error.message)
        : 'Realtime connection error';
    return { kind: 'ERROR', message };
  }
  return null;
}
